var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"id":"modalSobre","ok-only":true,"ok-variant":"danger","ok-title":"Fechar","size":"lg","title":"Sobre"}},[_c('img',{attrs:{"src":require("../../public/assets/img/sobre.jpeg"),"width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }